function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.array.is-array.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';
import { mapState } from 'vuex';
export default {
  name: 'NestedDashboardOptionsEditor',
  props: {
    value: {
      type: Object,
      required: true
    },
    customParameters: {
      type: Object,
      required: false,
      "default": function _default() {}
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), mapState('dashboards', ['dashboards'])), {}, {
    nestedDashboardId: {
      get: function get() {
        return this.getByKey('dashboardId');
      },
      set: function set(val) {
        if (!val) {
          this.setByKey(null, undefined);
          return;
        }
        this.setByKey('dashboardId', val);
      }
    },
    nestedDashboardDefinition: function nestedDashboardDefinition() {
      var _this = this;
      var def = this.dashboards.find(function (dashboard) {
        return dashboard.id === _this.nestedDashboardId;
      });
      return def ? def.value : {};
    },
    eventParametersAsSelectItems: function eventParametersAsSelectItems() {
      var customParametersAsSelectItems = Object.keys(this.customParameters).map(function (key) {
        return "{{dashboard.parameter.".concat(key, "}}");
      });
      return ['{{event.dtwin.id}}', '{{event.dtwin.title}}'].concat(_toConsumableArray(customParametersAsSelectItems));
    },
    navigationType: {
      get: function get() {
        return this.getByKey('navigationType');
      },
      set: function set(val) {
        this.setByKey('navigationType', val);
      }
    },
    navigationTypeItems: function navigationTypeItems() {
      var _this2 = this;
      var options = ['navigate', 'replace'];
      return options.map(function (option) {
        return {
          text: _this2.$t("Dashboards.nestedDashboard.navigationType.".concat(option)),
          value: option
        };
      });
    }
  }),
  methods: {
    getByKey: function getByKey(key, defaultValue) {
      return get(this.value, key, defaultValue);
    },
    setByKey: function setByKey(key, val) {
      if (key === null) {
        this.$emit('input', null);
        return;
      }
      var clone = cloneDeep(this.value || {});
      if (key.startsWith('parameters.') && val === null) {
        val = undefined;
      }
      set(clone, key, val);
      if (key === 'dashboardId' && !clone.navigationType) {
        set(clone, 'navigationType', 'navigate');
      }
      this.$emit('input', clone);
    }
  }
};